import { AboutHero } from './sections/hero';
import { AboutOrigin } from './sections/origin';
import { AboutPrinciples } from './sections/principles';
import { AboutProcess } from './sections/process';

import { CONTACT_DETAILS } from '@/features/contact/contact-details';
import { HomeCta } from '@/features/home/sections/cta';
import { clientEnv } from '@/lib/env';
import { Seo } from '@/lib/seo';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  url: `${clientEnv.siteUrl}/about`,
  mainEntity: {
    '@type': 'RealEstateAgent',
    name: clientEnv.siteName,
    url: clientEnv.siteUrl,
    email: CONTACT_DETAILS.email,
    telephone: CONTACT_DETAILS.phones[0]?.value,
    address: {
      '@type': 'PostalAddress',
      streetAddress: CONTACT_DETAILS.addressLines[1],
      addressLocality: 'Ahmedabad',
      addressRegion: 'Gujarat',
      addressCountry: 'IN',
    },
  },
};

export default function AboutPage() {
  return (
    <>
      <Seo
        title="About Us"
        description="A transparency-first real estate platform for India's growth corridors — verified inventory, investment intelligence and a first-class journey for every buyer."
        path="/about"
        jsonLd={jsonLd}
      />
      <AboutHero />
      <AboutOrigin />
      <AboutPrinciples />
      <AboutProcess />
      <HomeCta />
    </>
  );
}
